import React from 'react';
import cc from 'classnames';

import styles from './StatusLabel.module.css';

interface IStatusLabel {
  type: 'approved' | 'rejected' | 'in progress' | 'pending' | 'recalled' | 'processing' | 'failed' | 'unknown';
}

const StatusLabel = ({ type }: IStatusLabel) => {
  switch (type) {
    case 'approved':
      return <div className={cc(styles.statusLabel, styles.statusLabel_approved)}>Approved</div>;
    case 'rejected':
      return <div className={cc(styles.statusLabel, styles.statusLabel_rejected)}>Rejected</div>;
    case 'failed':
      return <div className={cc(styles.statusLabel, styles.statusLabel_rejected)}>Failed</div>;
    case 'in progress':
      return <div className={cc(styles.statusLabel, styles.statusLabel_inprogress)}>In Progress</div>;
    case 'pending':
      return <div className={cc(styles.statusLabel, styles.statusLabel_pending)}>Pending</div>;
    case 'recalled':
      return <div className={cc(styles.statusLabel, styles.statusLabel_recalled)}>Recalled</div>;
    case 'processing':
      return <div className={cc(styles.statusLabel, styles.statusLabel_pending)}>Processing</div>;
    default:
      return <div className={cc(styles.statusLabel, styles.statusLabel_unknown)}>Unknown</div>;
  }
};

export default StatusLabel;
